import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

// Plain div on purpose: this used to be a framer `motion.div layout`, which animated every
// panel's box from its widget size to its fullscreen size (stretching the content inside)
// each time the module switched layout. The fullscreen switch is now a clean cut.
export default function FormContent({ isLoading, noRadius, fullscreen, children, noStyle }) {
  return (
    <div className={noStyle ? null : cx(styles.wrapper, { isLoading, fullscreen, noRadius })}>
      {children}
    </div>
  )
}
